// extracted by mini-css-extract-plugin
module.exports = {"variationToggle":"variationToggle_variationToggle__7_bsj","variation":"variationToggle_variation__369zA","variationColor":"variationToggle_variationColor__2bMTG"};